// BE invalid_fields key → GameForm field name. Used to translate an API field
// error into the form's inline error map, and to look up titles for the
// summary toast when a key has no inline slot.
export const GAME_BE_TO_FORM_FIELD: Record<string, string> = {
  starts_at: 'startsAt',
  ends_at: 'durationMinutes',
  duration: 'durationMinutes',
  home_team_id: 'homeTeamId',
  visiting_team_id: 'visitingTeamId',
  venue_id: 'venueId',
  facility_id: 'facilityId',
  league_game_number: 'gameNumber',
  game_type_id: 'gameTypeId',
  schedule_id: 'scheduleId',
  if_necessary_status: 'ifNecessaryStatus',
  is_upcoming_livestream: 'isUpcomingLivestream',
}

// BE invalid_fields key → human title for the summary toast.
export const GAME_BE_TO_FIELD_TITLE: Record<string, string> = {
  starts_at: 'Start Date And Time',
  ends_at: 'Duration',
  duration: 'Duration',
  home_team_id: 'Home Team',
  visiting_team_id: 'Visiting Team',
  venue_id: 'Location',
  facility_id: 'Facility',
  league_game_number: 'Game Number',
  game_type_id: 'Game Type',
  schedule_id: 'Sub Competition',
  if_necessary_status: 'If Necessary',
  is_upcoming_livestream: 'Upcoming LiveStream',
}
